module.exports = __webpack_public_path__ + "img/logo-seadevil-highlight@2x.bddf8e14.png";